import type { SupremeAffixCollectionType } from '@/types/equip'
import type { ItemType } from '@/types/item'
import type { UserAttrType } from '@/types/user'

export let supremeBasicFactor: Partial<UserAttrType> = {}
export function setSupremeBasicFactor(data: Partial<UserAttrType>) {
  supremeBasicFactor = data
}
export let supremeAffixCollection: SupremeAffixCollectionType = {}
export function setSupremeAffixCollection(data: SupremeAffixCollectionType) {
  supremeAffixCollection = data
}

export function getSupremeBasicAttrValue(key: keyof UserAttrType, value: number) {
  // @ts-ignore
  const res = supremeBasicFactor[key]! * value
  if (['crt', 'crtd', 'hr', 'atksp', 'ad', 'sce', 'cda', 'windDa', 'fireDa', 'waterDa', 'soilDa'].includes(key)) return res.toFixed(1)
  return Math.round(res)
}

const refineHitFactor: Record<number, number> = {
  0: 1,
  1: 1.3,
  2: 1.8,
  3: 2.4,
}
export function getSupremeAffixBasicAttrValue(key: keyof UserAttrType, value: number, refineHitCount: number) {
  const res = value * refineHitFactor[refineHitCount]
  if (['crt', 'crtd', 'hr', 'atksp', 'ad', 'sce', 'cda', 'windDa', 'fireDa', 'waterDa', 'soilDa'].includes(key)) return Number(res.toFixed(1))
  return Math.round(res)
}
export function getSupremeRealAffixList(supremeAttrs: ItemType['supremeAttrs'], supremeEngraveAttr: ItemType['supremeEngraveAttr']) {
  const affixList = supremeAttrs?.affixList || []
  if (!supremeEngraveAttr) return affixList
  affixList[supremeEngraveAttr.affixIndex] = supremeEngraveAttr.affixKey
  return affixList
}

export const engraveSupremeMaxQulityMap: Record<number, string> = {
  1: 'race',
  2: 'epic',
  3: 'epic',
  4: 'epic',
  5: 'legend',
}
